import { Component, OnInit } from '@angular/core';
import { CountryService } from 'src/app/services/countries/country.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrls: ['./countries.component.css']
})
export class CountriesComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  searchText: string = '';
  countries: any[] = [];
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public isLoading: boolean = false;

  constructor(
        private countryService: CountryService
      ){}

  ngOnInit(): void {
    this.isLoading=true;
    this.fetchCountries();
  }

  fetchCountries():void{
      this.countryService.getAllCountries().subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.countries = response.data
            this.isLoading=false;
          }else{
            this.errorMessage=response.message;
            this.isLoading=false;
          }
        },
        error: (error) => {
          this.errorMessage=error;
          this.isLoading=false;
        }
      });
    }

    pageChangeEvent(event: number){
      this.page = event;
      this.fetchCountries();
    }

    onSearchTextChange(event: Event) {
      this.searchText = (event.target as HTMLInputElement).value;
    }

    delete(event: Event,Id:string){
      event.preventDefault();
      this.confirmDelete(Id);
    }

    confirmDelete(Id: string){
        Swal.fire({
          title: 'Confirm Delete',
          text: 'Are you sure you want to delete this record? The action is irreversible!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes!',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.value) {
            this.isLoading=true;

            this.countryService.delete(Id)
            .subscribe({
              next: (response) => {
                if(response.status==='success'){
                  this.isLoading=false;
                  this.successMessage=response.message;
                  this.errorMessage=''; //Clear error message incase it's available

                  //Reload countries
                  this.fetchCountries();
                }else if(response.status==='error'){
                  this.isLoading=false;
                  this.errorMessage=response.message;
                }else{
                  this.isLoading=false;
                  this.errorMessage=response.message;
                }
              },
              error: (error) => {
                this.isLoading=false;
                this.errorMessage=error;
              }
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {

        }
    })
  }
}
